/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Show or hide reference model</h4>

<p>Show or hide the imported reference model.</p>`;

export default function ShowSTLTooltip() {
    return h('div', { innerHTML: body });
}
